<template>
    <div class="main">
        <div class="background">
            <video class="video"  muted src="../static/video/background.mp4" autoplay  loop="loop"></video>
        </div>
        <el-container>
            <keep-alive>
                <router-view name="main"></router-view>
            </keep-alive>
        </el-container>
    </div>
</template>

<script>
    import '@/assets/css/public.css';
    export default {
        name: 'App',
        components: {}
    }
</script>

<style scoped lang="less">
    .main{
        width: 100%;
        height: 100%;
        background-color: rgba(39,39,40,0.3);
        .background{
            position:absolute;
            width: 100%;
            height: 100%;
            overflow: hidden;
            z-index: -1;
            .video{
                width: 100%;
                height: 100%;
                object-fit: fill;
                overflow: hidden;
                background-size: 100% 100%;
            }
        }
        /deep/ .el-container{
            width: 1366px;
            height: 100%;
            margin: 0 auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue